import type { SVGProps } from "react";
export interface AirConditionerIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AirConditionerIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AirConditionerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.875 18a1.125 1.125 0 0 1 2.25 0c0 .727.003 1.584-.143 2.39-.15.828-.474 1.693-1.187 2.406a1.125 1.125 0 0 1-1.59-1.59c.286-.288.464-.674.564-1.22.103-.569.106-1.213.106-1.986m5 4v-4a1.125 1.125 0 0 1 2.25 0v4a1.125 1.125 0 0 1-2.25 0m5-4a1.125 1.125 0 0 1 2.25 0c0 .773.003 1.417.106 1.986.087.478.234.833.462 1.106l.102.113.078.085a1.126 1.126 0 0 1-1.583 1.582l-.085-.076-.25-.274c-.541-.655-.805-1.407-.937-2.133-.146-.805-.144-1.662-.144-2.389Zm1-4v-2a.875.875 0 0 0-.875-.874H8a.875.875 0 0 0-.875.874v2a1.125 1.125 0 0 1-2.25 0v-2A3.125 3.125 0 0 1 8 8.875h8A3.125 3.125 0 0 1 19.125 12v2a1.125 1.125 0 0 1-2.25 0m3-8.5a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141A1.375 1.375 0 0 1 18.5 4.125l.14.007c.694.07 1.235.656 1.235 1.368m-3.5 0a1.375 1.375 0 0 1-2.743.141l-.008-.14.008-.141a1.375 1.375 0 0 1 2.743.14"
      />
      <path
        fill={color}
        d="M20.875 5c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v6c0 1.036.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.875zm2.25 6A4.125 4.125 0 0 1 19 15.125H5A4.125 4.125 0 0 1 .875 11V5A4.125 4.125 0 0 1 5 .875h14A4.125 4.125 0 0 1 23.125 5z"
      />
    </svg>
  );
}
